import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'


export default function Create_Projects() {
  var trgtextarea = '';
  var def_proj_name = ''
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0];
    document.getElementById("pro_deadline").setAttribute("min", today);
    document.getElementById("pro_deadline").addEventListener("change", function () {
      const selectedDate = new Date(this.value);
      const currentDate = new Date();

      // Calculate the difference in milliseconds
      const difference = selectedDate - currentDate;

      // Convert milliseconds to days
      const daysDifference = Math.ceil(difference / (1000 * 60 * 60 * 24));

      document.getElementById("result_days").innerText = `Remaining Days: ${daysDifference} days`;
    });
    function getTodaysDate() {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const dd = String(today.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    }
    $('#pro_deadline').val(getTodaysDate());
  }, [])

  function openPopForHelpReq() {
    var projname = $('#proname').val();
    if (projname === '') {
      showAlert('Please insert a project name')
    } else {
      def_proj_name = $('#proname').val();
      $('#poptoask').css('display', 'block')
      $('#query_heading').text('Give project type and functionality hints');
      trgtextarea = 'proReq';
    }
  }

  function openPopForHelpspec() {
    var projname = $('#proname').val();
    if (projname === '') {
      showAlert('Please insert a project name')
    } else {
      def_proj_name = $('#proname').val();
      $('#poptoask').css('display', 'block')
      $('#query_heading').text('Give project type and functionality hints');
      $('#exampletext').text('A little bit about your project, Give a short description what type of project you want to build actually and if there is anything special functionality.')
      trgtextarea = 'prodetails';
    }
  }

  function closeAPIPOP() {
    $('#poptoask').css('display', 'none')
    trgtextarea = '';
  }

  async function sendQuery() {
    var prtype = document.getElementById('prtype').value;
    var prfetures = document.getElementById('features_pr').value;

    var txtval = 'We want to develope a ' + prtype + ' project with functionality/features  like ' + prfetures;
    if (txtval === '') {
      showAlert('Insert your query text');
    } else {
      document.getElementById('loader').style.display = 'block';
      var obj = {
        'primary_query': 'We have a project with the name' + def_proj_name + '. Here is the short description of the project : ' + txtval + '. Can you please give me a complete workflow of how we can execute the project along with all other details like technology, type of expertise. do not add any other extra text or comments'
      };

      try {
        const response = await fetch('http://localhost/vilicus/app_project/get_help_api.php', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(obj)
        });

        const data = await response.json();
        const jsondata = JSON.parse(data)
        const messageArray = jsondata.choices;
        var msg = messageArray[0].message;
        var cont = msg.content;
        $('#' + trgtextarea).val(cont)
        // formattext(msg);
        closeAPIPOP();
        document.getElementById('loader').style.display = 'none';
      } catch (error) {
        console.error('Error:', error);
        showAlert('An error occurred while sending the request.');
        document.getElementById('loader').style.display = 'none';
      }
    }
  }

  function formattext(msg) {
    const lines = msg.split("\n"); // Split text into lines
    const result = {};

    lines.forEach(line => {
      const parts = line.split(":"); // Split by colon
      if (parts.length > 1) { // Ensure there's a key-value structure
        const key = parts[0].trim(); // Trim whitespace from the key
        const value = parts.slice(1).join(":").trim(); // Join back in case of extra colons in value
        result[key] = value;
      }
    });
    var str = formatJsonToText(result);
    $('#' + trgtextarea).val(str)
  }

  function formatJsonToText(data) {
    let text = "";
    for (let key in data) {
      if (data[key] === "") {
        text += `\n${key}\n`;
      } else {
        text += `\n${key}: ${data[key]}\n`;
      }
    }
    return text;
  }

  function create_your_project() {
    var company_id = localStorage.getItem('mem_company_id');
    let projname = $('#proname').val();
    var pro_details = $('#prodetails').val();
    const today = new Date().toLocaleDateString('en-CA');
    var dateOFentry = today;
    var deadline = $('#pro_deadline').val();

    if (projname === '') {
      showAlert('Please insert your project name')
    } else {
      var obj = {
        'project_name': projname,
        'project_spec': pro_details,
        'project_entry': dateOFentry,
        'project_end': deadline,
        'pr_company_id': company_id
      };
      $.ajax({
        type: 'POST',
        url: 'save_project.php',
        data: obj,
        cache: false,
        success: function (result) {
          if (result !== 'fail') {
            let proid = result ? result.trim() : '';
            localStorage.setItem('proname', projname);
            localStorage.setItem('current_project_id', proid);
            localStorage.setItem('current_project_deadline', deadline);
            document.getElementById('addfile').classList.remove('nodisplay')
            //navigate('/manage_team');
          } else {
            alert('Cannot save your project. Please  try again');
          }
        },
      });
    }

  }
  function closeAddFilePOP() {
    document.getElementById('addfile').classList.add('nodisplay')
    navigate('/manage_team');
  }

  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  function calculaterestdays() {
    var trgdate = $('#pro_deadline').val();

  }

  const uploadfiles = async () => {
    const fileInput = document.getElementById("project_file");
    const files = fileInput.files;

    if (files.length === 0) {
      alert("Please select at least one file");
      return;
    }

    const formData = new FormData();

    // append multiple files
    for (let i = 0; i < files.length; i++) {
      formData.append("files[]", files[i]);
    }

    // extra data
    formData.append("pro_name", localStorage.getItem("proname"));
    formData.append("pro_id", localStorage.getItem("current_project_id"));

    formData.append(
      "description",
      "This file is for documented the project. Please read/view all files before start working on the project."
    );

    try {
      const res = await fetch("upload_files.php", {
        method: "POST",
        body: formData,
      });

      const result = await res.json();

      if (result.status === "success") {
        alert("Files uploaded successfully");
        navigate('/manage_team');
      } else {
        alert(result.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };


  return (
    <div>
      <Topbar toggleSidebar={toggleSidebar} />
      <Sidebar_component sidebarOpen={sidebarOpen} />
      <div className='vl_dsh_bodypart'>
        <section className='vl_dsh_bodypart_section'>
          <div className='create_heading'>
            <h2>Create a new project</h2>
          </div>
          <div className='help_text_area'>
            <p>READ FIRST :<br></br> <br></br> <span>To create a new project, you first need to define its name. After that, you will be guided through a series of steps, such as adding a short project description, creating a to-do list, and assembling a team.<br></br><br></br>

              You can also add your client as an observer. Observers can view all updates and upcoming tasks but cannot make any changes. However, they can share their opinions by sending messages.<br></br><br></br>

              Once the project is created, it will appear in the project list, where you can also assign tasks directly. </span> </p>
          </div>

          <div className='vl_dsh_formnholder mt-50 bigheading'>
            <h2>Insert your project information</h2>
            <div className='formfieldcommon'>
              <label>Insert your project name**</label>
              <input type="text" id="proname" />
            </div>

            <div className='formfieldcommon'>
              <label>Enter your project details (optional, but it helps in better tracking and progress).</label>
              <h3 className='ailink' onClick={openPopForHelpspec}>Create content with AI<i class="ri-apps-fill"></i></h3>
              <textarea id="prodetails"></textarea>
            </div>
            <div className='formfieldcommon datecount'>
              <label>Insert your project deadline**</label>
              <input type="date" id="pro_deadline" on /><span id="result_days">Remaining days</span>
            </div>
            <div className='formfieldcommon'>
              <button onClick={create_your_project}>Create Project</button>
            </div>
          </div>
        </section>
      </div>
      <div className='vl_dsh_popup' id="poptoask">
        <div className='vl_dsh_pop_content'>
          <button className='vl_dsh_pop_content_close' onClick={closeAPIPOP}>+</button>

          <div className='questionarea'>
            <h2 id="query_heading"></h2>
            <p id="exampletext"></p>
            <div className='query_form'>
              <div className='formfieldholder'>
                <label>Define the Type Of Project</label>
                <input type="text" id="prtype" />
              </div>
              <div className='formfieldholder'>
                <label>Special functionality you want to sadd in your project</label>
                <textarea id="features_pr"></textarea>
              </div>
            </div>
            <div className='vl_dsh_api_button_holder'>
              <button onClick={sendQuery}>Send Request</button>
            </div>
          </div>
        </div>
      </div>

      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button>
          </div>
        </div>
      </div>

      <div className='vl_dsh_popup z-9999' id="loader">
        <div className='loadertext'>Please wait, AI agent is working</div>
      </div>

      <div className='vl_dsh_popup_vis nodisplay' id="addfile">
        <div className='vl_dsh_pop_content'>
          <button className='vl_dsh_pop_content_close' onClick={closeAddFilePOP}>+</button>
          <h2 className='vl_dsh_pop_content_heading'>Upload Files</h2>
          <div className='upload_section'>
            <div className='formfieldholder'>
              <p>Upload your files here to access them later in the Files tab of the Project Details page. These files will be treated as project documentation. Supported formats: PDF, DOCX, PNG, JPG, GIF, ZIP, and RAR.</p>
            </div>
            <div className='formfieldholder'>
              <input type="file" id="project_file" multiple />
            </div>
            <div className='buttonholder'>
              <button onClick={uploadfiles}>Uplaod</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
